import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { Avatar } from "@memorang/ui/components/Avatar";
import Box from "@memorang/ui/components/Box";
import RowStats, { type Stat } from "@memorang/ui/components/RowStats";
import { useAppTheme } from "@memorang/ui/useAppTheme";
type Props = {
	avatarSize?: number;
	stats: Stat[];
};

const ProfileHeader = ({ avatarSize = 96, stats }: Props) => {
	const theme = useAppTheme();
	const { username } = useAuthContext();
	return (
		<>
			{username ? (
				<Box alignItems="center" justifyContent="center">
					<Avatar
						size={avatarSize}
						username={username ?? ""}
						style={{
							borderWidth: 3,
							borderColor: theme.colors.secondary,
						}}
					/>
				</Box>
			) : null}
			<RowStats stats={stats} maxWidth={"100%"} />
		</>
	);
};

export default ProfileHeader;
